import moment from 'moment';
import React from 'react';

const BOOKING_STATUS_COLORS = {
  hotels: {
    CONFIRM: '#00c659',
    CANCELLED: '#ffcb00',
    'PRE-BOOKING': '#2798d8',
    FAILED: '#ed1c24',
    DENIED: '#f7ab48',
    REQUIRES_REVIEW: '#ae7de2',
  },

  flights: {
    Emitido: '#00c659',
    Cancelado: '#ffcb00',
    'En cola': '#ae7de2',
    Pendiente: '#2798d8',
    Fallo: '#ed1c24',
    Parcial: '#f7ab48',
  },

  assist: {
    1: '#00c659',
    2: '#2798d8',
    3: '#ed1c24',
  },
};

export const useBookingColor = product => {
  const colorMap = {
    ...BOOKING_STATUS_COLORS[product],
  };

  return status => {
    return colorMap[status] || '';
  };
};

export const formatDate = dateString => moment(dateString).format('DD/MM/YYYY');

export const getHref = bookingDetails => {
  const { latitude, longitude, address } = bookingDetails?.entity || {};

  if (latitude?.length > 6) {
    return (
      <a
        href={`https://www.google.com/maps/search/?api=1&query=${latitude}%2C${longitude}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {address}
      </a>
    );
  }

  return address;
};
